/* Herram · Sinónimos del buscador. Traduce palabras que usa el cliente a las del catálogo
   antes de buscar (en la búsqueda normal y en las sugerencias al escribir).
   r = reemplaza la palabra; o = busca la palabra original O la del catálogo. */
(function () {
  if (window.__herramSyn) return;
  window.__herramSyn = true;
  var MAP = {
    'galletero': ['r', 'esmeril angular'],
    'galleteros': ['r', 'esmeril angular'],
    'galletera': ['r', 'esmeril angular'],
    'galleteras': ['r', 'esmeril angular'],
    'amoladora angular': ['r', 'esmeril angular'],
    'amoladora': ['o', 'esmeril angular'],
    'esmeriladora': ['o', 'esmeril angular'],
    'motoguadaña': ['r', 'desbrozadora'],
    'motoguadana': ['r', 'desbrozadora'],
    'maceta': ['r', 'mazo'],
    'macetas': ['r', 'mazo'],
    'torquimetro': ['r', 'llave torque'],
    'torquímetro': ['r', 'llave torque'],
    'trinquete': ['r', 'chicharra'],
    'matraca': ['o', 'chicharra']
  };
  var keys = Object.keys(MAP).sort(function (a, b) { return b.length - a.length; });
  function expand(q) {
    var t = (q || '').trim().toLowerCase();
    if (!t || t.indexOf(' or ') > -1) return null;
    for (var i = 0; i < keys.length; i++) {
      var k = keys[i], re = new RegExp('(^|\\s)' + k.replace(/[.*+?^${}()|[\]\\]/g, '\\$&') + '(?=\\s|$)');
      if (!re.test(t)) continue;
      var m = MAP[k];
      if (t === k) return m[0] === 'o' ? k + ' OR "' + m[1] + '"' : m[1];
      return t.replace(re, '$1' + m[1]);
    }
    return null;
  }
  // Sugerencias al escribir: el tema las pide a /search/suggest con fetch.
  var f = window.fetch;
  window.fetch = function (input, init) {
    try {
      var url = typeof input === 'string' ? input : input && input.url;
      if (url && url.indexOf('/search/suggest') > -1) {
        var u = new URL(url, location.origin), x = expand(u.searchParams.get('q'));
        if (x) {
          var orig = u.searchParams.get('q');
          u.searchParams.set('q', x);
          // El texto «Buscar “…”» debe mostrar lo que escribió el cliente; si no, el script del tema falla al seguir escribiendo.
          return f.call(this, u.pathname + u.search, init).then(function (r) {
            return r.text().then(function (t) {
              var safe = orig.replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;');
              t = t.replace(/(data-predictive-search-search-for-text>)[\s\S]*?(<\/span>)/, '$1Buscar “' + safe + '”$2');
              return new Response(t, { status: r.status, statusText: r.statusText, headers: r.headers });
            });
          });
        }
      }
    } catch (e) {}
    return f.call(this, input, init);
  };
  // Búsqueda normal: cambia la consulta al enviar y guarda lo que escribió el cliente.
  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form || !/\/search(\?|$)/.test(form.getAttribute('action') || '')) return;
    var q = form.querySelector('input[name="q"]');
    var x = q && expand(q.value);
    if (!x) return;
    e.preventDefault();
    var p = new URLSearchParams(new FormData(form));
    p.set('q', x);
    p.set('hq', q.value.trim());
    location.href = form.getAttribute('action') + '?' + p.toString();
  }, true);
  // En la página de resultados, el buscador muestra lo que escribió el cliente.
  var sp = new URLSearchParams(location.search), hq = sp.get('hq');
  // Si se llegó a la búsqueda sin pasar por el envío (por ejemplo, desde un enlace), se corrige aquí.
  if (!hq && /^\/search\/?$/.test(location.pathname)) {
    var x0 = expand(sp.get('q'));
    if (x0) { sp.set('hq', sp.get('q')); sp.set('q', x0); location.replace(location.pathname + '?' + sp.toString()); return; }
  }
  if (hq) {
    var put = function () { document.querySelectorAll('input[name="q"]').forEach(function (i) { i.value = hq; }); };
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', put); else put();
  }
})();
